import {REST_ENDPOINT} from '../../endpoints';

export default class HelperService {
  // eslint-disable-next-line class-methods-use-this
  getRandomId(length) {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOP';
    let pass = '';
    // eslint-disable-next-line no-plusplus
    for (let x = 0; x < length; x++) {
      const i = Math.floor(Math.random() * chars.length);
      pass += chars.charAt(i);
    }

    return pass;
  }

  /**
   * Build a query string from a filters object using key value pairs
   * */
  buildSearchQueryString(filters) {
    let query = '?';

    // eslint-disable-next-line no-restricted-syntax
    for (const key in filters) {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        query += `${key}=${filters[key]}&`;
      }
    }

    query = query.substr(0, query.length - 1); // remove any extra '&' symbols

    return query;
  }

  getWeekdays() {
    return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  }

  /**
   * Check if the browser is IE
   * @returns {boolean}
   */
  isIe() {
    const ua = window.navigator.userAgent;
    return /MSIE|Trident/.test(ua);
  }

  getCookieValue(key) {
    let name = key + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  switchToOldSite() {
    let domain = 'purplevisitsportal.com';
    document.cookie = `portalNew=false;path=/;domain=${domain}`; // set the cookie

    if(REST_ENDPOINT.includes('dev') || REST_ENDPOINT.includes('localhost')) {
      window.location = 'https://dev.purplevisitsportal.com';
    } else if (REST_ENDPOINT.includes('prod')) {
      window.location = 'https://www.purplevisitsportal.com';
    }
  }

}
